(() => {
  let pending;
  window.silveraddaLoadSwiper = () => {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (pending) return pending;
    pending = new Promise((resolve, reject) => {
      if (!document.getElementById('silveradda-swiper-css')) {
        const link = document.createElement('link');
        link.id = 'silveradda-swiper-css';
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
        document.head.appendChild(link);
      }
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      script.async = true;
      script.onload = () => resolve(window.Swiper);
      script.onerror = () => { pending = undefined; reject(new Error('Carousel script failed to load')); };
      document.head.appendChild(script);
    });
    return pending;
  };
})();